import type { RouterProps } from 'contracts/Router';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { BASE_TRACKING_V2_PATH, TRACKING_V2_ROUTES } from 'lib/routes';

import {
  InvoicesTrackingPage,
  InvoiceDetailsPage,
  TripsTrackingPage,
  CreateTripPage,
  DeliveryVouchersPage,
  TripDetailsPage,
} from 'pages/tracking-v2';

export const trackingV2Routes = ({
  isLoggedIn,
  location,
  hasPermissionTo,
}: RouterProps): RouteObject => ({
  path: BASE_TRACKING_V2_PATH,
  element: isLoggedIn
    ? <Outlet />
    : <Navigate to={'/'} state={{ from: location }} />,
  children: [
    {
      path: TRACKING_V2_ROUTES.invoicesTracking().path,
      element: <InvoicesTrackingPage />,
    },
    {
      path: TRACKING_V2_ROUTES.invoiceDetails().path,
      element: <InvoiceDetailsPage />,
    },
    {
      path: TRACKING_V2_ROUTES.tripsTracking().path,
      element: <TripsTrackingPage />,
    },
    {
      path: TRACKING_V2_ROUTES.createTrip().path,
      element: <CreateTripPage />,
    },
    {
      path: TRACKING_V2_ROUTES.deliveryVouchers().path,
      element: hasPermissionTo(TRACKING_V2_ROUTES.deliveryVouchers().permissions)
        ? <DeliveryVouchersPage />
        : <Navigate to={'/'} state={{ from: location }} />,
    },
    {
      path: TRACKING_V2_ROUTES.tripDetails().path,
      element: <TripDetailsPage />,
    },
  ],
});
